/**
 * Screens an invite must never interrupt: timed, scored, on camera, or paying.
 *
 * The old check was `pathname.includes('/play')`, which matched any path with
 * those five letters anywhere and — more to the point — missed every focused
 * screen that does not happen to use the word: a live interview, a guided topic
 * test, a job assessment. The sound plays too, so anything that slips through is
 * audible, not merely visible.
 */
const DO_NOT_DISTURB = [
  /\/play(\/|$)/, // every play screen
  /^\/skill-builder\/multiplayer\/[^/]+/, // a room or the arena
  /^\/interview\/[^/]+\/join/, // on camera with a recruiter
  /^\/course\/[^/]+\/test\//, // a scored topic test
  /^\/evaluation-assessment\//,
  /\/assessment(\/|$)/,
  /^\/onboarding/, // a first run we do not want derailed
  /^\/store/, // mid-purchase
];

const isDoNotDisturbPath = (pathname: string) =>
  DO_NOT_DISTURB.some((path) => path.test(pathname));

export default isDoNotDisturbPath;
